// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__372Ie","info":"Note_info__2Nw7n","note":"Note_note__3Qmlh","actions":"Note_actions__1k-IW"};